import { extendObservable, runInAction } from 'mobx';

import { ApiHttpService } from '../networking/ApiHttpService';
import { Logger } from '../helpers/Logger';
import { Storage } from '../helpers/Storage';
import { ParametersController } from '../networking/controllers/ParametersController';
import { constants } from '../config';

const PARAMETERS_STORAGE_KEY = 'configstore-parameters';
const WEB_TOGGLE_STORAGE_KEY = 'configstore-intranet-toggle';
const MAX_RETRIES = 3;

class ConfigParametersStoreClass {
  constructor() {
    extendObservable(this, {
      parameters: null,
      // This parameter only makes sense when showIntranet === true
      webToggled: false,
      get isIntranet() {
        return this.parameters && !!this.parameters.intraSearchFilters &&
          !!this.parameters.intraSearchFilters.length;
      },
      get showIntranet() {
        return !this.webToggled && this.isIntranet;
      },
    });
    this.retries = 0;
    this.fetchParametersFromStorage();
    this.fetchWebToggleFromStorage();
  }

  toggleWeb() {
    runInAction(() => {
      this.webToggled = !this.webToggled;
    });
    Storage.set(WEB_TOGGLE_STORAGE_KEY, this.webToggled);
  }

  fetchWebToggleFromStorage() {
    const toggleValue = Storage.get(WEB_TOGGLE_STORAGE_KEY);
    runInAction(() => {
      this.webToggled = !!toggleValue;
    });
    if (this.webToggled && this.isIntranet) {
      // When the intranet user wants to see the web, we should send
      // the web parameter as true everywhere.
      ApiHttpService.setHeaders({
        web: 'true',
      });
    }
  }

  fetchParametersFromStorage() {
    const parameters = Storage.get(PARAMETERS_STORAGE_KEY);
    if (parameters) {
      Logger.log('Config Parameters found on storage');
      runInAction(() => {
        this.parameters = parameters;
      });
    }
    if (constants.refreshConfigParams) {
      Storage.remove(PARAMETERS_STORAGE_KEY);
    }
    this.fetchParameters();
  }

  async fetchParameters() {
    if (this.retries > MAX_RETRIES) {
      Logger.warn('Parameter fetching exceeded retry limit.');
      return;
    }
    try {
      const parameters = await ParametersController.all();
      Storage.set(PARAMETERS_STORAGE_KEY, parameters);
      this.retries = 0;
      runInAction(() => {
        this.parameters = parameters;
      });
      Logger.log('Parameters loaded correctly');
    } catch (error) {
      Logger.warn(`Failed to fetch parameters, retried ${this.retries} times, error was: ${error.message}`);
      // Retry
      this.retries += 1;
      this.fetchParameters();
    }
  }
}

const ConfigParametersStore = new ConfigParametersStoreClass();

export { ConfigParametersStore };



// WEBPACK FOOTER //
// ./src/stores/ConfigParametersStore.js